import React, { useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import validator from 'validator';
import { urlConfig } from '../../config/urlConfig';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import {
  accessTokenRequest,
  sendRequest,
} from '../../services/global/global.service';
import FormDialog from './forgot-password-modal';

const useStyle = makeStyles((theme) => {
  return {
    textField: {
      marginBottom: theme.spacing(2),
    },
    saveButton: {
      margin: '1rem 0',
    },
    submitBox: {
      display: 'flex',
      alignItems: 'center',
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
    },
    wrapper: {
      margin: '24px 16px 24px 0',
      position: 'relative',
    },
    buttonProgress: {
      color: '#000',
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    link: {
      color: theme.ui.secondary,
      textDecoration: 'none',
      backgroundColor: '#fff',
      marginRight: 3,
      marginLeft: 3,
      '&:hover': {
        backgroundColor: '#fff',
      },
    },
  };
});

export const ChangePassword = () => {
  const classes = useStyle();
  const history = useHistory();
  // const { isConnect } = useContext(ProfileContext);

  const currentPasswordRef = useRef(null);
  const newPasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);

  const [currentPassword, setCurrentPassword] = useState('');
  const [currentPasswordError, setCurrentPasswordError] = useState(false);

  const [newPassword, setNewPassword] = useState('');
  const [newPasswordError, setNewPasswordError] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [open, setOpen] = React.useState(false);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      setOpen(false);
    }
    setOpen(false);
  };

  const changePassword = (data) => {
    setIsLoading(true);
    setError(null);

    accessTokenRequest()
      .then((response) => {
        sendRequest(urlConfig.change_password_url, response, 'post', data)
          .then((res) => {
            setOpen(true);
            setIsLoading(false);
          })
          .catch((e) => {
            setIsLoading(false);
            e.response.data.old_password &&
              setError(e.response.data.old_password);
            e.response.data.new_password2 &&
              setError(e.response.data.new_password2);
          });
      })
      .catch((e) => {
        setIsLoading(false);
        console.log('refresh token error: ', e.response);
      });
  };

  const submitHandler = (e) => {
    e.preventDefault();

    // if (!isConnect) {
    if (validator.isEmpty(currentPassword)) {
      setCurrentPasswordError(true);
      currentPasswordRef.current.focus();
    }
    if (validator.isEmpty(newPassword)) {
      setNewPasswordError(true);
      if (!validator.isEmpty(currentPassword)) {
        newPasswordRef.current.focus();
      }
    }
    if (validator.isEmpty(confirmPassword)) {
      setConfirmPasswordError(true);
      if (newPassword && currentPassword !== '') {
        confirmPasswordRef.current.focus();
      }
    }

    if (newPassword && confirmPassword) {
      if (newPassword !== confirmPassword) {
        setError(`The two password fields didn't match.`);
        return false;
      }

      if (newPassword.length < 8) {
        setError(
          'This password is too short. It must contain at least 8 characters.This password is too common.'
        );
        return false;
      }
    }

    // } else {
    //   if (validator.isEmpty(newPassword)) {
    //     setNewPasswordError(true);
    //     newPasswordRef.current.focus();
    //   }
    //   if (validator.isEmpty(confirmPassword)) {
    //     setConfirmPasswordError(true);
    //     confirmPasswordRef.current.focus();
    //   }
    // }

    // if (isConnect && newPassword && confirmPassword) {
    //   let data = {
    //     new_password2: newPassword,
    //     new_password1: confirmPassword,
    //   };
    //   changePassword(data);
    // } else
    if (currentPassword && newPassword && confirmPassword) {
      let data = {
        old_password: currentPassword,
        new_password2: newPassword,
        new_password1: confirmPassword,
      };
      changePassword(data);
    }
  };

  return (
    <div>
      <form noValidate autoComplete='off' onSubmit={submitHandler}>
        <input
          autoComplete='false'
          name='hidden'
          type='text'
          style={{ display: 'none' }}
        />
        <TextField
          fullWidth
          className={classes.textField}
          label='Current Password'
          inputRef={currentPasswordRef}
          error={currentPasswordError}
          autoComplete='new-password'
          inputProps={{
            autoComplete: 'new-password',
            form: {
              autoComplete: 'new-password',
            },
          }}
          value={currentPassword}
          onChange={(e) => {
            setCurrentPassword(e.target.value);
            setCurrentPasswordError(false);
          }}
          type='password'
          required
        />

        <TextField
          fullWidth
          className={classes.textField}
          label='New Password'
          error={newPasswordError}
          inputRef={newPasswordRef}
          type='password'
          autoComplete='off'
          inputProps={{
            autoComplete: 'off',
            form: {
              autoComplete: 'off',
            },
          }}
          value={newPassword}
          onChange={(e) => {
            setNewPassword(e.target.value);
            setNewPasswordError(false);
          }}
          required
        />
        <TextField
          fullWidth
          label='Confirm New Password'
          autoComplete='off'
          inputProps={{
            autoComplete: 'off',
            form: {
              autoComplete: 'off',
            },
          }}
          helperText={
            <Typography color='error' variant='caption'>
              {error}
            </Typography>
          }
          error={confirmPasswordError}
          inputRef={confirmPasswordRef}
          type='password'
          value={confirmPassword}
          onChange={(e) => {
            setConfirmPassword(e.target.value);
            setConfirmPasswordError(false);
          }}
          required
        />

        <div className={classes.submitBox}>
          <Box className={classes.container}>
            <div className={classes.wrapper}>
              <Button
                type='submit'
                color='primary'
                variant='contained'
                className={classes.saveButton}
                size='small'
                id='change-password'
                disabled={isLoading}
              >
                Save
              </Button>
              {isLoading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
            <Button
              size='small'
              variant='outlined'
              disabled={isLoading}
              onClick={() => history.push('/meetings')}
            >
              Discard Changes
            </Button>
          </Box>
          <FormDialog />
        </div>
      </form>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        TransitionComponent='alpha'
        message='password changed successfully'
        action={
          <React.Fragment>
            <IconButton
              size='small'
              aria-label='close'
              color='inherit'
              onClick={handleClose}
            >
              <CloseIcon fontSize='small' />
            </IconButton>
          </React.Fragment>
        }
      />
    </div>
  );
};
